<template lang="pug">
    span(class="_badge", :class="{ _v:visible && ((value && dvalue) || $slots.default) }", inert)
        slot {{dvalue}}
</template>

<script>
    /**
    * DEPRECATED. Use ib-badge2.
    */
    export default {
        name: 'ib-badge',

        props: {
            value: Number,
            max: {
                type: Number,
                default: 1000
            },
            visible: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                dvalue: null,
                dtimeout: null
            }
        },

        mounted() {
            this.$nextTick(this.update);
        },

        watch: {
            value() {
                this.update();
            }
        },

        methods: {
            reset() {
                this.dvalue = 0;
            },

            update() {
                const to = this.value;
                if (!to) {
                    if (!this.dtimeout) {
                        this.dtimeout = setTimeout(this.reset, 180);
                    }
                } else {
                    if (this.dtimeout) {
                        clearTimeout(this.dtimeout);
                        this.dtimeout = null;
                    }
                    this.dvalue = to > this.max ? this.max + '+' : to;
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._badge {
        position: absolute;
        padding: 2.5px 3.5px;
        border-radius: 99px;
        line-height: 1;
        .font-size(11);
        font-weight: 600;
        background-color: @bg-negative;
        color: #fff;
        box-shadow: 2px 2px 4px rgba(0,0,0,0.2);
        visibility: hidden;
        min-width: calc(~'1em + 5px');
        text-align: center;
        transform: scale(.01);
        transition:
            transform .15s linear,
            visibility 0s linear .15s;

        &._v {
            visibility: visible;
            transform: scale(1);
            transition:
                transform .15s linear;
        }
        svg {
            margin: -2.5px;
            vertical-align: -1.5px;
        }
    }
</style>

<docs>
    Basic Example:
    ```jsx
        new Vue({
            data() {
                return {
                    value: 0,
                    visible: true
                }
            },
            template:
                `<ib-context>
                    <p class="before-md after-md">
                        <ib-button @click="value++">
                            Click Me
                            <ib-badge :value="value" :max="10"/>
                        </ib-button>
                        <ib-button @click="value = 0">
                            Reset
                        </ib-button>
                        <ib-button @click="visible = !visible">
                            Custom
                            <ib-badge :visible="visible" class="bg-positive">
                                <svg viewBox="0 0 24 24"><path d="M19.28 5.28L9 15.56l-4.28-4.28-1.44 1.44 5 5 .72.69.72-.7 11-11z"/></svg>
                            </ib-badge>
                        </ib-button>
                    </p>
                </ib-context>`
        })
    ```
</docs>
